__webpack_require__.p = "https://www.newcornerstonefoundation.org.cn/";